<div [formGroup]="timeRecordingForm">
    <div class="row mb-3 justify-content-end">
        <label
            for="billablePresetDropDown"
            class="col-12 col-md-2 col-form-label text-md-end text-start"
            [translate]="'CONFIRMATION_TIMERECORDING_CONFIRM_PRESET_BILLABLE'"
        >
        </label>

        <div class="col-12 col-md-3">
            <pace-core-dropdown
                id="billablePresetDropDown"
                [parentForm]="timeRecordingFormChildren"
                [(model)]="model.billablePresetModel"
                (valueChange)="onBillablePresetChange()"
            >
            </pace-core-dropdown>
        </div>
        @if (enableAfterHourCallOut && hasAnyOSREntry()) {
            <div class="col-12 col-md-3 d-flex align-items-center mt-3 mt-md-0">
                <label
                    for="afterHoursCallOut"
                    class="col-form-label mb-sm-1 mb-0 me-2 text-nowrap text-end"
                    [translate]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_AFTERHOURS_CALL_OUT'"
                ></label>
                <pace-core-checkbox-input
                    id="afterHoursCallOut"
                    class="w-auto"
                    [(model)]="model.afterHourCallOut"
                    [parentForm]="timeRecordingFormChildren"
                ></pace-core-checkbox-input>
            </div>
        }
    </div>

    <hr class="separator d-block d-lg-none" />

    <!-- MOBILE LAYOUT -->
    @if (isMobile$ | async) {
        <div>
            @for (timeRecEntry of model.timeRecordingEntries.value; track timeRecEntry) {
                <div>
                    <div class="row mb-3">
                        <div class="col-8">
                            <span class="col-form-label">
                                <span [translate]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_TYPE_OF_WORK'"></span>
                                <span class="px-1">/</span>
                                <span [translate]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_ACTIVITY'"></span>
                            </span>
                        </div>
                        <div class="col text-end">
                            @if (shouldShowDeleteEntryButton(timeRecEntry)) {
                                <button
                                    type="button"
                                    class="btn btn-warning"
                                    (click)="deleteEntry($index)"
                                    [attr.aria-label]="
                                        'CONFIRMATION_TIMERECORDING_CONFIRM_DELETE_ENTRY_ARIA_LABEL' | translate
                                    "
                                >
                                    <fa-icon [icon]="faTrashAlt"></fa-icon>
                                </button>
                            }
                        </div>
                    </div>
                    <div class="row">
                        @if (isGeneralEntry(timeRecEntry) && !isBreakEntryBetweenTravelEntries(timeRecEntry)) {
                            <div class="col-6">
                                <pace-core-dropdown
                                    [parentForm]="timeRecordingFormChildren"
                                    [(model)]="timeRecEntry.typeOfWorkModel"
                                    (valueChange)="onTypeOfWorkChange($event, timeRecEntry)"
                                >
                                </pace-core-dropdown>
                            </div>
                        }
                        @if (isLimitedEntry(timeRecEntry) || isBreakEntryBetweenTravelEntries(timeRecEntry)) {
                            <div class="col-6">
                                <label
                                    [attr.for]="'activitiesDropDown-' + $index"
                                    class="col-form-label fw-normal text-start"
                                >
                                    {{ timeRecEntry.typeOfWorkDescription }}</label
                                >
                            </div>
                        }
                        <div class="col-6">
                            @if (shouldShowActivityDropdown(timeRecEntry)) {
                                <pace-core-dropdown
                                    [id]="'activitiesDropDown-' + $index"
                                    [parentForm]="timeRecordingFormChildren"
                                    [(model)]="timeRecEntry.activitiesModel"
                                >
                                </pace-core-dropdown>
                            }
                            @if (displayMeansOfTransport) {
                                <div class="travel-dropdown">
                                    @if (isLimitedEntry(timeRecEntry)) {
                                        <pace-core-dropdown
                                            [parentForm]="timeRecordingFormChildren"
                                            [(model)]="timeRecEntry.meansOfTransport"
                                            id="meansOfTravelDropDown"
                                        ></pace-core-dropdown>
                                    }
                                </div>
                            }
                        </div>
                        @if (displayAdditionalTravelInfo) {
                            <div class="col-6">
                                @if (displayMeansOfTransport) {
                                    <div class="travel-dropdown">
                                        @if (isLimitedEntry(timeRecEntry)) {
                                            <pace-core-dropdown
                                                [parentForm]="timeRecordingFormChildren"
                                                [(model)]="timeRecEntry.meansOfTransport"
                                                id="meansOfTravelDropDown"
                                            >
                                            </pace-core-dropdown>
                                        }
                                    </div>
                                }
                                <div class="travel-dropdown"></div>
                            </div>
                        }
                    </div>
                    <!-- Start date and time -->
                    <div class="row mb-2">
                        <div class="col-12">
                            <label
                                [attr.for]="'startDate-' + $index"
                                class="col-form-label"
                                [translate]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_START'"
                            >
                            </label>
                        </div>
                        <div class="col-7">
                            <pace-core-date-input
                                [id]="'startDate-' + $index"
                                [parentForm]="timeRecordingFormChildren"
                                [(model)]="timeRecEntry.startDateModel"
                                (valueChange)="changeDurationForSingleEntry(timeRecEntry)"
                                [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_STARTDATE' | translate"
                            >
                            </pace-core-date-input>
                        </div>
                        <div class="col-5">
                            <pace-core-time-input
                                [parentForm]="timeRecordingFormChildren"
                                [(model)]="timeRecEntry.startTimeModel"
                                (valueChange)="changeDurationForSingleEntry(timeRecEntry)"
                                [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_STARTTIME' | translate"
                            >
                            </pace-core-time-input>
                        </div>
                    </div>
                    <!-- End date and time -->
                    <div class="row mb-2">
                        <div class="col-12">
                            <label
                                [attr.for]="'endDate-' + $index"
                                class="col-form-label"
                                [translate]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END'"
                            >
                            </label>
                        </div>
                        <div class="col-7">
                            <pace-core-date-input
                                [id]="'endDate-' + $index"
                                [parentForm]="timeRecordingFormChildren"
                                [(model)]="timeRecEntry.endDateModel"
                                (valueChange)="changeStartTimeForSubsequentEntries(timeRecEntry)"
                                [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END_DATE' | translate"
                            >
                            </pace-core-date-input>
                        </div>
                        <div class="col-5">
                            <pace-core-time-input
                                [parentForm]="timeRecordingFormChildren"
                                [(model)]="timeRecEntry.endTimeModel"
                                [dateModel]="timeRecEntry.endDateModel"
                                (valueChange)="changeStartTimeForSubsequentEntries(timeRecEntry)"
                                [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END_TIME' | translate"
                            >
                            </pace-core-time-input>
                        </div>
                    </div>
                    <!-- VALIDATION MESSAGES for a specific entry-->
                    <div class="row mt-3">
                        @for (validationEntry of allFalsyValidationResults; track validationEntry) {
                            @if (validationEntry.showAtId === timeRecEntry.id) {
                                <div class="col-12">
                                    <div class="alert alert-danger" role="alert">
                                        {{ validationEntry.validationErrorMessage }}
                                    </div>
                                </div>
                            }
                        }
                        <!-- VALIDATION WARNINGS for a specific entry-->
                        @for (validationEntry of allValidationWarnings; track validationEntry) {
                            @if (validationEntry.showAtId === timeRecEntry.id) {
                                <div class="col-12">
                                    <div class="alert alert-warning" role="alert">
                                        {{ validationEntry.validationErrorMessage }}
                                    </div>
                                </div>
                            }
                        }
                    </div>

                    <!-- ADD TRAVEL TO button for Korea -->
                    @if (displayAdditionalTravelToButton(timeRecEntry)) {
                        <div class="row mb-3">
                            <div class="col">
                                <button
                                    type="button"
                                    class="btn btn-primary float-start"
                                    (click)="addTravelToEntry(timeRecEntry)"
                                    [translate]="'CONFIRMATION_TIMERECORDING_ADD_TRAVEL_TO_LABEL'"
                                ></button>
                            </div>
                        </div>
                    }
                    <!-- WARNING MESSAGES for a specific entry-->
                    @if (computedWarnings[timeRecEntry.id]?.hasAnyWarnings) {
                        <div class="row">
                            <div class="col-12">
                                <div class="alert alert-warning" role="alert">
                                    @if (computedWarnings[timeRecEntry.id]?.isEntryDurationEqualOrExceeding24Hours) {
                                        <p [translate]="'CONFIRMATION_TIMERECORDING_WARNING_ENTRY_EXCEEDING_24H'"></p>
                                    }
                                    @if (
                                        computedWarnings[timeRecEntry.id]?.isGeneralEntryDurationExceeding10Hours &&
                                        !computedWarnings[timeRecEntry.id]?.isEntryDurationEqualOrExceeding24Hours
                                    ) {
                                        <p [translate]="'CONFIRMATION_TIMERECORDING_WARNING_ENTRY_EXCEEDING_10H'"></p>
                                    }
                                    @if (computedWarnings[timeRecEntry.id]?.isOvernightEntry) {
                                        <p [translate]="'CONFIRMATION_TIMERECORDING_WARNING_ENTRY_OVERNIGHT'"></p>
                                    }
                                    @if (computedWarnings[timeRecEntry.id]?.isEntryFollowedByGapOf10HoursOrMore) {
                                        <p [translate]="'CONFIRMATION_TIMERECORDING_WARNING_ENTRY_GAP_10H'"></p>
                                    }
                                    @if (computedWarnings[timeRecEntry.id]?.isEntriesHavingAnUnoccupiedGap) {
                                        <p [translate]="'CONFIRMATION_TIMERECORDING_WARNING_ENTRY_GAP'"></p>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                    <!-- Duration -->
                    <div class="row mb-2">
                        <div class="col-4 d-flex align-items-center">
                            <span
                                class="col-form-label"
                                [translate]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_DURATION'"
                            >
                            </span>
                        </div>
                        @if (timeRecEntry.getFormattedDuration()) {
                            <span class="col col-form-label fw-normal text-start"
                                >{{ timeRecEntry.getFormattedDuration() }}
                            </span>
                        }
                    </div>
                    <!-- Billable -->
                    <div class="row mb-5">
                        <div class="col-4">
                            <label
                                [attr.for]="'billableDropDown-' + $index"
                                class="col-form-label"
                                [translate]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_BILLABLE'"
                            >
                            </label>
                        </div>
                        <div class="col">
                            <pace-core-dropdown
                                [id]="'billableDropDown-' + $index"
                                [parentForm]="timeRecordingFormChildren"
                                [(model)]="timeRecEntry.billableModel"
                                (valueChange)="onBillableChange()"
                            >
                            </pace-core-dropdown>
                        </div>
                    </div>
                    <!-- Add new entry form section -->
                    <div class="position-relative mb-5">
                        <hr class="separator" />
                        <button
                            type="button"
                            (click)="displayIndexedAddNewEntryForm($index)"
                            class="add-entry-round-btn d-flex align-items-center justify-content-center rounded-circle btn btn-primary rounded-circle position-absolute start-50 top-50 translate-middle"
                            [attr.aria-label]="
                                (clickedTimeRecEntryIndex === $index && clickedTimeRecEntryIndex >= 0
                                    ? 'CONFIRMATION_TIMERECORDING_CONFIRM_CANCEL_ENTRY_ARIA_LABEL'
                                    : 'CONFIRMATION_TIMERECORDING_CONFIRM_ADD_ENTRY_ARIA_LABEL'
                                ) | translate
                            "
                        >
                            <fa-icon
                                [icon]="
                                    clickedTimeRecEntryIndex === $index && clickedTimeRecEntryIndex >= 0
                                        ? faTimes
                                        : faPlus
                                "
                            ></fa-icon>
                        </button>
                    </div>
                    @if (clickedTimeRecEntryIndex === $index) {
                        <div class="col-12">
                            <ng-container *ngTemplateOutlet="addNewTimeRecordEntryForm"></ng-container>
                        </div>
                    }
                </div>
            }
        </div>
    } @else {
        <div class="row">
            <div class="col-1 limited-col-width px-0"></div>
            <div class="col-6 ps-0">
                <span class="col-form-label">
                    <span [translate]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_START'"></span>
                    <span class="px-1">/</span>
                    <span [translate]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END'"></span>
                </span>
            </div>
            <div class="col-4 text-center">
                <span class="col-form-label" [translate]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_DURATION'"></span>
            </div>
        </div>
        @for (timeRecEntry of model.timeRecordingEntries.value; track timeRecEntry) {
            <div>
                <div class="row mt-3">
                    <div class="col-1 limited-col-width pe-0">
                        @if (shouldShowDeleteEntryButton(timeRecEntry)) {
                            <button
                                type="button"
                                class="btn btn-warning"
                                (click)="deleteEntry($index)"
                                [attr.aria-label]="
                                    'CONFIRMATION_TIMERECORDING_CONFIRM_DELETE_ENTRY_ARIA_LABEL' | translate
                                "
                            >
                                <fa-icon [icon]="faTrashAlt"></fa-icon>
                            </button>
                        }
                    </div>
                    <!-- Left hand section: Start / End and Type of Work -->
                    <div class="col-6">
                        <!-- START DATE AND TIME -->
                        <div class="row gap-2">
                            <div class="col-5 p-0">
                                <pace-core-date-input
                                    [parentForm]="timeRecordingFormChildren"
                                    [(model)]="timeRecEntry.startDateModel"
                                    (valueChange)="changeDurationForSingleEntry(timeRecEntry)"
                                    [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_STARTDATE' | translate"
                                >
                                </pace-core-date-input>
                            </div>
                            <div class="col-3 p-0">
                                <pace-core-time-input
                                    [parentForm]="timeRecordingFormChildren"
                                    [(model)]="timeRecEntry.startTimeModel"
                                    (valueChange)="changeDurationForSingleEntry(timeRecEntry)"
                                    [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_STARTTIME' | translate"
                                >
                                </pace-core-time-input>
                            </div>
                            <!-- TYPE OF WORK -->
                            @if (isGeneralEntry(timeRecEntry) && !isBreakEntryBetweenTravelEntries(timeRecEntry)) {
                                <div class="col p-0">
                                    <pace-core-dropdown
                                        [parentForm]="timeRecordingFormChildren"
                                        [(model)]="timeRecEntry.typeOfWorkModel"
                                        (valueChange)="onTypeOfWorkChange($event, timeRecEntry)"
                                    >
                                    </pace-core-dropdown>
                                </div>
                            }
                            <!-- TYPE OF WORK for TRAV and breaks inserted into travel time -->
                            @if (isLimitedEntry(timeRecEntry) || isBreakEntryBetweenTravelEntries(timeRecEntry)) {
                                <div class="col d-flex align-items-center">
                                    <span>{{ timeRecEntry.typeOfWorkDescription }}</span>
                                </div>
                            }
                        </div>
                        <!-- End Date and Time-->
                        <div class="row mt-1 gap-2">
                            <div class="col-5 p-0">
                                <pace-core-date-input
                                    [parentForm]="timeRecordingFormChildren"
                                    [(model)]="timeRecEntry.endDateModel"
                                    (valueChange)="changeStartTimeForSubsequentEntries(timeRecEntry)"
                                    [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END_DATE' | translate"
                                >
                                </pace-core-date-input>
                            </div>
                            <div class="col-3 p-0">
                                <pace-core-time-input
                                    [parentForm]="timeRecordingFormChildren"
                                    [(model)]="timeRecEntry.endTimeModel"
                                    [dateModel]="timeRecEntry.endDateModel"
                                    (valueChange)="changeStartTimeForSubsequentEntries(timeRecEntry)"
                                    [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END_TIME' | translate"
                                >
                                </pace-core-time-input>
                            </div>
                        </div>
                    </div>
                    <!-- Right hand section -->
                    <div class="col-5">
                        <div class="row">
                            <div class="col-4">
                                <!-- ACTIVITY P58-->
                                @if (shouldShowActivityDropdown(timeRecEntry)) {
                                    <pace-core-dropdown
                                        [parentForm]="timeRecordingFormChildren"
                                        [(model)]="timeRecEntry.activitiesModel"
                                    >
                                    </pace-core-dropdown>
                                }
                                <!-- MEANS OF TRANSPORT NGMP58 (JP)-->
                                @if (displayMeansOfTransport) {
                                    <div class="travel-dropdown">
                                        @if (isLimitedEntry(timeRecEntry)) {
                                            <pace-core-dropdown
                                                [parentForm]="timeRecordingFormChildren"
                                                [(model)]="timeRecEntry.meansOfTransport"
                                                id="meansOfTravelDropDown"
                                            ></pace-core-dropdown>
                                        }
                                    </div>
                                }
                            </div>
                            <!-- ADDITIONAL TRAVEL INFO NGMAA -->
                            @if (displayAdditionalTravelInfo) {
                                <div class="col-4">
                                    @if (displayMeansOfTransport) {
                                        <div class="travel-dropdown">
                                            @if (isLimitedEntry(timeRecEntry)) {
                                                <pace-core-dropdown
                                                    [parentForm]="timeRecordingFormChildren"
                                                    [(model)]="timeRecEntry.meansOfTransport"
                                                    id="meansOfTravelDropDown"
                                                >
                                                </pace-core-dropdown>
                                            }
                                        </div>
                                    }
                                    <!-- DESTINATION -->
                                    <div class="travel-dropdown"></div>
                                </div>
                            }
                            <!-- DURATION -->
                            <div class="col-2 text-center d-flex align-items-center">
                                @if (timeRecEntry.getFormattedDuration()) {
                                    <span>
                                        {{ timeRecEntry.getFormattedDuration() }}
                                    </span>
                                }
                            </div>
                            <!-- BILLABLE -->
                            <div class="col-4">
                                <pace-core-dropdown
                                    [parentForm]="timeRecordingFormChildren"
                                    [(model)]="timeRecEntry.billableModel"
                                    id="billableDropDown"
                                    (valueChange)="onBillableChange()"
                                >
                                </pace-core-dropdown>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- VALIDATION MESSAGES for a specific entry-->
                <div class="row mt-3">
                    <div class="col-1 limited-col-width"></div>
                    <div class="col-11 flex-lg-grow-1 ps-0">
                        @for (validationEntry of allFalsyValidationResults; track validationEntry) {
                            @if (validationEntry.showAtId === timeRecEntry.id) {
                                <div class="alert alert-danger" role="alert">
                                    {{ validationEntry.validationErrorMessage }}
                                </div>
                            }
                        }
                        <!-- VALIDATION WARNINGS for a specific entry-->
                        @for (validationEntry of allValidationWarnings; track validationEntry) {
                            @if (validationEntry.showAtId === timeRecEntry.id) {
                                <div class="alert alert-warning" role="alert">
                                    {{ validationEntry.validationErrorMessage }}
                                </div>
                            }
                        }
                    </div>
                </div>

                <!-- ADD TRAVEL TO button for Korea -->
                @if (displayAdditionalTravelToButton(timeRecEntry)) {
                    <div class="row mb-3">
                        <div class="col-1 limited-col-width"></div>
                        <div class="col ps-0">
                            <button
                                type="button"
                                class="btn btn-primary float-start"
                                (click)="addTravelToEntry(timeRecEntry)"
                                [translate]="'CONFIRMATION_TIMERECORDING_ADD_TRAVEL_TO_LABEL'"
                            ></button>
                        </div>
                    </div>
                }
                <!-- WARNING MESSAGES for a specific entry-->
                @if (computedWarnings[timeRecEntry.id]?.hasAnyWarnings) {
                    <div class="row">
                        <div class="col-1 limited-col-width"></div>
                        <div class="col-11 flex-lg-grow-1 ps-0">
                            <div class="alert alert-warning" role="alert">
                                @if (computedWarnings[timeRecEntry.id]?.isEntryDurationEqualOrExceeding24Hours) {
                                    <p [translate]="'CONFIRMATION_TIMERECORDING_WARNING_ENTRY_EXCEEDING_24H'"></p>
                                }
                                @if (
                                    computedWarnings[timeRecEntry.id]?.isGeneralEntryDurationExceeding10Hours &&
                                    !computedWarnings[timeRecEntry.id]?.isEntryDurationEqualOrExceeding24Hours
                                ) {
                                    <p [translate]="'CONFIRMATION_TIMERECORDING_WARNING_ENTRY_EXCEEDING_10H'"></p>
                                }
                                @if (computedWarnings[timeRecEntry.id]?.isOvernightEntry) {
                                    <p [translate]="'CONFIRMATION_TIMERECORDING_WARNING_ENTRY_OVERNIGHT'"></p>
                                }
                                @if (computedWarnings[timeRecEntry.id]?.isEntryFollowedByGapOf10HoursOrMore) {
                                    <p [translate]="'CONFIRMATION_TIMERECORDING_WARNING_ENTRY_GAP_10H'"></p>
                                }
                                @if (computedWarnings[timeRecEntry.id]?.isEntriesHavingAnUnoccupiedGap) {
                                    <p [translate]="'CONFIRMATION_TIMERECORDING_WARNING_ENTRY_GAP'"></p>
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
        }
    }
    <!-- END OF MOBILE LAYOUT -->

    <!-- DESKTOP LAYOUT -->
    <!-- END OF DESKTOP LAYOUT-->
</div>

<!-- VALIDATION MESSAGES of general-->
@if (falsyValidationResultsCommon.length > 0) {
    <div class="row">
        <div class="col-12">
            <div class="alert alert-warning" role="alert">
                @for (validationEntry of falsyValidationResultsCommon; track validationEntry) {
                    <p>
                        {{ validationEntry.validationErrorMessage }}
                    </p>
                }
            </div>
        </div>
    </div>
}

<hr class="separator d-none d-lg-block" />

<!-- BUTTONS -->
<div class="row">
    <div class="col d-flex justify-content-between">
        @if (!displayNewEntryForm) {
            <button
                type="button"
                class="btn btn-primary"
                (click)="resetTimeRecording()"
                [translate]="'CONFIRMATION_TIMERECORDING_RESET_LABEL'"
            ></button>
        }
        @if (shouldShowAddEntryButton()) {
            <button
                type="button"
                class="btn btn-primary d-lg-block d-none"
                (click)="toggleShowNewEntryForm()"
                [disabled]="disableAddNewEntryForm()"
                [translate]="'CONFIRMATION_TIMERECORDING_ADD_ENTRY_LABEL'"
            ></button>
        }
    </div>
</div>

<!-- ADD ENTRY FORM -->
@if (displayNewEntryForm) {
    <ng-container *ngTemplateOutlet="addNewTimeRecordEntryForm"></ng-container>
}

<ng-template #addNewTimeRecordEntryForm>
    <pace-add-time-recording-entry-form
        [timeRecordingModel]="model"
        [parentForm]="timeRecordingFormChildren"
        (timeRecordingSaved)="insertEntry($event)"
        (changesDiscarded)="hideNewEntryForm()"
    >
    </pace-add-time-recording-entry-form>
</ng-template>

@if (otherTimeSheetEntries.length > 0) {
    <pace-time-sheet-entries
        [otherTimeSheetEntries]="otherTimeSheetEntries"
        [model]="model"
        [enableStandbyTravel]="enableStandbyTravel"
    >
    </pace-time-sheet-entries>
}
